import React from "react";

const SocialMediaIcon = ({ highlighted }) => {
  return (
    <img
      className="h-[1.1rem] w-[1.1rem]"
      src={
        highlighted
          ? require("../assets/Group 1000001171.png")
          : require("../assets/Group 1000001168.png")
      }
    />
  );
};

export default SocialMediaIcon;
